import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import moment from 'moment';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { WorkerCalendarEvent } from '../../_types/worker-calendar-event';
import { WorkersCalendarsEventsService } from '../../_services/workers-calendars-events.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { CalendarsEventsTypesService } from 'src/app/modules/calendars/_services/calendars-events-types.service';
import { firstValueFrom } from 'rxjs';
import { CalendarEventType } from 'src/app/modules/calendars/_types/calendar-event-type';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { CasesService } from 'src/app/modules/cases/_services/cases.service';
import { CasesServicesService } from 'src/app/modules/cases/_services/cases-services.service';
import { GuardsShiftsDatesService } from 'src/app/modules/guards-shifts/_services/guards-shifts-dates.service';
import { WorkerGuardShiftsService } from '../../_services/workers-guards-shifts.service';

@Component({
    selector: 'app-workers-calendars-events-details-modal.component',
    templateUrl: './workers-calendars-events-details-modal.component.html',
    standalone: false
})
export class WorkersCalendarsEventsDetailsModalComponent {

  public workerCalendarEventsFormGroup!: RxFormGroup;

  public workerCalendarEvent: WorkerCalendarEvent = new WorkerCalendarEvent;
  public calendarEventTypes: any = [];
  public calendarEventTypeSelected: any = {};
  public caseServices: any = [];
  
  public serviceFoundModal: boolean = false;
  public guardShiftFoundModal: boolean = false;
  public deleteWorkerCalendarEvents: boolean = false;
  public workerCalendarEvents: any = [];
  //public visibleDeleteMultipleModal: boolean = false;
  public deleteEventType: any = null;
  public isRange:boolean = false;
  public startRange:Date | null = null;
  public endRange:Date | null = null;


  constructor(
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private confirmationService: ConfirmationService,
    private workersCalendarsEventsServices: WorkersCalendarsEventsService,
    private formBuilder: RxFormBuilder,
    private calendarsEventsTypesService: CalendarsEventsTypesService,
    private casesServiceService: CasesServicesService,
    private formValidationService: FormValidatorService,
    private guardShiftDateServices: GuardsShiftsDatesService,
    private workerGuardShiftsService: WorkerGuardShiftsService,
    private workersCalendarsEventsService: WorkersCalendarsEventsService
  ) {
    this.workerCalendarEventsFormGroup = this.formBuilder.formGroup<WorkerCalendarEvent>(this.workerCalendarEvent) as RxFormGroup;
  }


  async ngOnInit(): Promise<void> {

    await this.loadCalendarEventTypes();

    this.workerCalendarEvent = this.config.data.event != null ? this.config.data.event : new WorkerCalendarEvent();

    //si tiene id, convertimos star y end en fechas
    if(this.workerCalendarEvent.id != null && this.workerCalendarEvent.id != ""){
      if(this.workerCalendarEvent.start != null){
        let start = new Date();
        start.setHours(this.workerCalendarEvent.start.split(":")[0], this.workerCalendarEvent.start.split(":")[1], this.workerCalendarEvent.start.split(":")[2]);
        this.workerCalendarEvent.start = start;        
      }
      if(this.workerCalendarEvent.end != null){
        let end = new Date();
        end.setHours(this.workerCalendarEvent.end.split(":")[0], this.workerCalendarEvent.end.split(":")[1], this.workerCalendarEvent.end.split(":")[2]);
        this.workerCalendarEvent.end = end;
      }
    }

    //si tiene tipo de evento, lo seleccionamos
    if(this.workerCalendarEvent.calendarEventTypeId != null){
      this.calendarEventTypeSelected = this.calendarEventTypes.find((m:any) => m.id == this.workerCalendarEvent.calendarEventTypeId);
    }

    //comprobamos si es un rango o un dia
    let start = moment(this.workerCalendarEvent.start);
    let end = moment(this.workerCalendarEvent.end);
    this.isRange = !start.isSame(end, 'day');
    if(this.isRange){
      this.startRange = this.workerCalendarEvent.start;
      this.endRange = this.workerCalendarEvent.end;
    }
    
    this.workerCalendarEventsFormGroup.patchValue(this.workerCalendarEvent);

    this.loadCaseServices();
    this.loadGuards();
  }

  async loadCalendarEventTypes() {
    let params: IParamsCollection = {
      sort: ['name']
    };
    let response = await firstValueFrom(this.calendarsEventsTypesService.all(params));
    this.calendarEventTypes = response.data;
  }

  async loadCaseServices(){
    let filters = {
      workerId: new Filter(FilterOperation.equals, 'workerId', '', this.workerCalendarEvent.workerId),
      fromDate: new Filter(FilterOperation.greaterOrEqual, 'date', '',this.workerCalendarEvent.start != null? moment(this.workerCalendarEvent.start).startOf("day").toISOString(): moment(this.workerCalendarEvent.date!).startOf("day").toISOString()),
      toDate: new Filter(FilterOperation.lessOrEqual, 'date', '', this.workerCalendarEvent.end != null ?moment(this.workerCalendarEvent.end).endOf("day").toISOString() : moment(this.workerCalendarEvent.date!).endOf("day").toISOString()),
      isCancelled: new Filter(FilterOperation.equals, 'isCancelled', '', false)
    }
    
    let params: IParamsCollection = {       
      filter: FilterBuilder.fromObject(filters).build()
    };

    let response = await firstValueFrom(this.casesServiceService.all(params));
    if(response.data.length > 0){
      this.caseServices = response.data;
      this.serviceFoundModal = true;
    }
  }

  async editWorkerCalendarEvent(event: any){
  }

  async deleteWorkerCalendarEvent(event: any){
  }

  async loadGuards(){

     let filtersWgs = {
      workerId: new Filter(FilterOperation.equals, 'workerId', '', this.workerCalendarEvent.workerId)
    }
     
     let paramsWSG: IParamsCollection = {       
       filter: FilterBuilder.fromObject(filtersWgs).build()
     };
 
     let response2 = await firstValueFrom(this.workerGuardShiftsService.all(paramsWSG));
     let guardShiftsIds = response2.data.filter(m => m.guardShiftId != null).map(m => m.guardShiftId);

    let filters = {
      guardShiftId: new Filter(FilterOperation.any, 'guardShiftId', '', guardShiftsIds),
       fromDate: new Filter(FilterOperation.greaterOrEqual, 'date', '',this.workerCalendarEvent.start != null? moment(this.workerCalendarEvent.start).startOf("day").toISOString(): moment(this.workerCalendarEvent.date!).startOf("day").toISOString()),
       toDate: new Filter(FilterOperation.lessOrEqual, 'date', '', this.workerCalendarEvent.end != null ?moment(this.workerCalendarEvent.end).endOf("day").toISOString() : moment(this.workerCalendarEvent.date!).endOf("day").toISOString()),
    }
     
     let params: IParamsCollection = {       
       filter: FilterBuilder.fromObject(filters).build()
     };
 
     let response = await firstValueFrom(this.guardShiftDateServices.all(params));

     if(response.data.length > 0){
       var guardShift = response.data;
       
       this.guardShiftFoundModal = true;
     }
  }

  async loadWorkerCaseServices(){
    let filters = {
      workerId: new Filter(FilterOperation.equals, 'workerId', '', this.workerCalendarEvent.workerId),
       fromDate: new Filter(FilterOperation.greaterOrEqual, 'date', '',this.workerCalendarEvent.start != null? moment(this.workerCalendarEvent.start).startOf("day").toISOString(): moment(this.workerCalendarEvent.date!).startOf("day").toISOString()),
       toDate: new Filter(FilterOperation.lessOrEqual, 'date', '', this.workerCalendarEvent.end != null ?moment(this.workerCalendarEvent.end).endOf("day").toISOString() : moment(this.workerCalendarEvent.date!).endOf("day").toISOString()),
       isCancelled: new Filter(FilterOperation.equals, 'isCancelled', '', false)
    }
     
     let params: IParamsCollection = {       
       filter: FilterBuilder.fromObject(filters).build()
     };
 
     let response = await firstValueFrom(this.casesServiceService.all(params));
     if(response.data.length > 0){
       this.caseServices = response.data;
       this.serviceFoundModal = true;
     }
  }

  onCalendarEventTypeChange(calendarEventType: any){     
    this.calendarEventTypeSelected = this.calendarEventTypes.find((m:any) => m.id == calendarEventType.value);
  }

  async save() {
    this.workerCalendarEvent = Object.assign(this.workerCalendarEvent, this.workerCalendarEventsFormGroup.value);

    //si tiene id es que estamos editando
    if(this.workerCalendarEvent.id != null && this.workerCalendarEvent.id != ""){
      this.workerCalendarEvent.start = new Date(this.workerCalendarEvent.start).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', second: '2-digit'});
      this.workerCalendarEvent.end = new Date(this.workerCalendarEvent.end).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', second: '2-digit'});   
      this.workerCalendarEvent = await firstValueFrom(this.workersCalendarsEventsService.save(this.workerCalendarEvent));
      this.messageService.add({ closable: true, severity: 'success', detail: "Evento modificado correctamente" });
    }else{
      //estamos creando, comprobamos si es la fecha de inicio y fin son del mismo dia
      if(!this.isRange){
        //mismo dia, creamos normal
        this.workerCalendarEvent.start = new Date(this.workerCalendarEvent.start).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', second: '2-digit'});
        this.workerCalendarEvent.end = new Date(this.workerCalendarEvent.end).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', second: '2-digit'});   
        this.workerCalendarEvent = await firstValueFrom(this.workersCalendarsEventsService.save(this.workerCalendarEvent));
      }else{
        //es un rango de dias, creamos varios eventos
        let startHour = new Date(this.workerCalendarEvent.start).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', second: '2-digit'});
        let endHour = new Date(this.workerCalendarEvent.end).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', second: '2-digit'});  
        await firstValueFrom(this.workersCalendarsEventsService.saveWorkerCalendarEventsRange(this.workerCalendarEvent.workerId, {
          startDate: this.startRange,
          endDate: this.endRange,
          calendarEventTypeId: this.workerCalendarEvent.calendarEventTypeId,
          start: startHour,
          end: endHour,
          description: this.workerCalendarEvent.description,
          keepCaseServices: this.workerCalendarEvent.keepCaseServices,
          keepGuardShifts: this.workerCalendarEvent.keepGuardShifts,
          list_dates: this.workerCalendarEvent.list_dates
        }));
      }
    }
    this.dynamicDialogRef.close(this.workerCalendarEvent);
  }


  dismiss() {
  }

  attendServices(response:boolean){

  }
}
